import { useNavigate } from 'react-router-dom';
import { useUserStore } from '@/entities/User';
import { useModalStore } from '@/entities/Modal';
import { ResponseError } from '@/shared/api/types';
import { useMutation } from '@tanstack/react-query';
import { login } from '../api/loginQuery';

export const useLogin = () => {
    const { setErrorModalProps } = useModalStore();
    const { setIsAuth, setIsNoData, setIsNoAccess } = useUserStore();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: login,
        onSuccess: (url) => {
            window.location.href = url;
        },
        onError: (error: ResponseError) => {
            const errorMessage = error.response.data.details[0] || 'Что-то пошло не так';

            if (errorMessage.includes('Договоры не найдены')) {
                setIsAuth(true);
                setIsNoData(true);
                navigate('/lk');

                return;
            }

            if (errorMessage.includes('Ваш договор находится на стадии оформления')) {
                setIsAuth(true);
                setIsNoAccess(true);
                navigate('/lk');

                return;
            }

            setErrorModalProps({ isOpened: true, title: errorMessage });
        },
    });
};
